// frontend/src/components/Results/CleaverGraficaIII.js
// Gráfica III del Cleaver (plantilla impresa) en la pantalla de resultados.
// El dibujo es el mismo del reporte PDF (utils/graficaCleaver.js).

import React, { useEffect, useRef } from 'react';
import { dibujarGraficaCleaver, ANCHO_GRAFICA, ALTO_GRAFICA } from '../../utils/graficaCleaver';

const CleaverGraficaIII = ({ grafica }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const escala = Math.max(2, Math.ceil(window.devicePixelRatio || 1));
    dibujarGraficaCleaver(canvasRef.current, grafica, escala);
  }, [grafica]);

  if (!grafica?.puntos) return null;

  const descripcion = ['D', 'I', 'S', 'C']
    .map(f => `${f}: T ${grafica.puntos[f].t >= 0 ? '+' : ''}${grafica.puntos[f].t}, segmento ${grafica.puntos[f].segmento}`)
    .join('; ');

  return (
    <div className="cleaver-grafica-iii">
      <canvas
        ref={canvasRef}
        style={{ width: '100%', maxWidth: ANCHO_GRAFICA, aspectRatio: `${ANCHO_GRAFICA} / ${ALTO_GRAFICA}` }}
        role="img"
        aria-label={`Gráfica III del Cleaver. ${descripcion}. Números de segmento ${grafica.codigo}. Patrón ${grafica.patron || 'no disponible'}.`}
      />
      <div className="cleaver-grafica-resumen">
        <div>
          <span>Números de segmentos</span>
          <strong>{grafica.codigo}</strong>
        </div>
        <div>
          <span>Patrón clásico</span>
          <strong>{grafica.patron || 'No disponible'}</strong>
        </div>
        <table>
          <thead>
            <tr><th>Factor</th><th>T (M − L)</th><th>Intensidad</th><th>Segmento</th></tr>
          </thead>
          <tbody>
            {['D', 'I', 'S', 'C'].map(f => (
              <tr key={f}>
                <td>{f}</td>
                <td>{grafica.puntos[f].t >= 0 ? '+' : ''}{grafica.puntos[f].t}</td>
                <td>{grafica.puntos[f].intensidad}</td>
                <td>{grafica.puntos[f].segmento}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CleaverGraficaIII;
